import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Note } from "./ui";

// Rendu en ligne : **gras**, [libellé](/chemin) et `code`.
export function Inline({ text }) {
  if (typeof text !== "string") return text;
  const parts = text.split(/(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\)|`[^`]+`)/g);
  return (
    <>
      {parts.map((part, i) => {
        if (!part) return null;
        if (part.startsWith("**") && part.endsWith("**")) return <strong key={i}>{part.slice(2, -2)}</strong>;
        if (part.startsWith("`") && part.endsWith("`")) return <code key={i}>{part.slice(1, -1)}</code>;
        const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
        if (link) {
          const [, label, href] = link;
          return href.startsWith("http")
            ? <a key={i} href={href} target="_blank" rel="noreferrer noopener">{label}</a>
            : <Link key={i} to={href}>{label}</Link>;
        }
        return <Fragment key={i}>{part}</Fragment>;
      })}
    </>
  );
}

function CodeBlock({ lang, value }) {
  const copy = () => navigator.clipboard?.writeText(value);
  return (
    <>
      <div className="docs-pre-head">
        <span>{lang}</span>
        <button type="button" onClick={copy} data-testid="code-copy">Copier</button>
      </div>
      <pre className="docs-pre"><code>{value}</code></pre>
    </>
  );
}

// Rend une liste de blocs décrits en données (voir content/docs.js, legal.js, help.js).
export default function Blocks({ blocks }) {
  return (
    <>
      {blocks.map((b, i) => {
        switch (b.t) {
          case "p": return <p key={i}><Inline text={b.v} /></p>;
          case "h3": return <h3 key={i}>{b.v}</h3>;
          case "ul": return <ul key={i}>{b.v.map((li, j) => <li key={j}><Inline text={li} /></li>)}</ul>;
          case "ol": return <ol key={i}>{b.v.map((li, j) => <li key={j}><Inline text={li} /></li>)}</ol>;
          case "code": return <CodeBlock key={i} lang={b.lang} value={b.v} />;
          case "note": return <Note key={i} kind={b.kind}><Inline text={b.v} /></Note>;
          case "table": return (
            <table key={i} className="kv-table">
              {b.head && b.head.some(Boolean) && <thead><tr>{b.head.map((h, j) => <th key={j}>{h}</th>)}</tr></thead>}
              <tbody>{b.rows.map((r, j) => <tr key={j}>{r.map((c, k) => <td key={k}><Inline text={c} /></td>)}</tr>)}</tbody>
            </table>
          );
          case "endpoint": return (
            <div key={i} className="docs-endpoint">
              <span className={`docs-verb ${b.verb.toLowerCase()}`}>{b.verb}</span>
              <code>{b.path}</code>
              {b.note && <em>{b.note}</em>}
            </div>
          );
          default: return null;
        }
      })}
    </>
  );
}
